import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Upload } from 'lucide-react';

export const ContactImportCard = ({ contacts_count, recommendations }) => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();
  const commonClasses = 'bg-white rounded-lg p-3 border border-gray-200';
  const iconWrapper = (
    <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
      <Upload className="h-6 w-6 text-blue-600" />
    </div>
  );

  const handleNavigation = (path) => {
    localStorage.setItem('activeTab', '/account/profile');
    navigate(path);
  };

  if (recommendations) {
    return (
      <div className={commonClasses}>
        <div className="flex items-center gap-6">
          {iconWrapper}
          <div className="flex-1">
            <h3 className="font-medium text-lg mb-1">{t('contacts.processingTitle')}</h3>
            <p className="text-gray-600 mb-4">{t('contacts.processingDescription')}</p>
            <button
              type="button"
              onClick={() => handleNavigation('/account/network')}
              className="bg-white border border-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-50 transition-colors flex items-center gap-2"
            >
              {t('contacts.manageContacts')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (contacts_count === 0) {
    return (
      <div className={commonClasses}>
        <div className="flex items-center gap-6">
          {iconWrapper}
          <div className="flex-1">
            <h3 className="font-medium text-lg mb-1">{t('contacts.importTitle')}</h3>
            <p className="text-gray-600 mb-4">{t('contacts.importDescription')}</p>
            <button
              type="button"
              onClick={() => handleNavigation('/account/network/sync-sources')}
              className="bg-blue-600 text-white px-4 py-2 rounded-md border-none hover:bg-blue-700 transition-colors"
            >
              {t('contacts.importButton')}
            </button>
          </div>
        </div>
      </div>
    );
  }
};
